import { createModel } from '@rematch/core';
import { IRootModel } from 'app/store';
import { INoteListState, INoteState } from 'entities/Notes/Note.models';
import { noteListReducers, noteReducers } from 'entities/Notes/Note.reducers';
import { noteEffects, noteListEffects } from 'entities/Notes/Note.effects';

export const noteList = createModel<IRootModel>()({
  state: {
    data: [],
    loading: false,
  } as INoteListState,
  reducers: noteListReducers,
  effects: noteListEffects,
});

export const note = createModel<IRootModel>()({
  state: {
    data: null,
    loading: false,
  } as INoteState,
  reducers: noteReducers,
  effects: noteEffects,
});
